var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeachAccess24Dp434343Fill0Wght400Grad0Opsz24 = function SvgBeachAccess24Dp434343Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#434343",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M784-120 530-374l56-56 254 254zm-546-28q-60-60-89-135t-29-153 29-152 89-134 134.5-89.5T525-841t152.5 29.5T812-722zm8-122 54-54q-16-21-30.5-43T243-411t-21-44-16-43q-11 59-1.5 118T246-270m112-110 222-224q-43-33-86.5-53.5t-81.5-28-68.5-2.5-47.5 22q-17 18-22 48.5t2.5 69 28 81.5 53.5 87m278-280 56-54q-53-32-112-42t-118 2q22 7 44 16t44 20.5 43.5 26T636-660"
  })));
};
export default SvgBeachAccess24Dp434343Fill0Wght400Grad0Opsz24;